// extracted by mini-css-extract-plugin
export var label = "_97-1";
export var reminder = "_97-0";